<template>
    <div class="footer-dashboard">
        <section class="footer-dashboard-title-subtitle">
            <div class="title-subtitle">
                <span class="fast-action">Ações Rápidas</span>
                <span class="information-infos">
                    Acompanhe informações importantes do seu negócio e realize ações de forma simples e rápida.
                </span>
            </div>
        </section>

        <section class="footer-dashboard-search-table">
            <div class="actions-search">
                <div class="client-reserves-proposal">
                    <span
                        :class="{ 'clients-active': active.name === 'dashboard-deals-list' }"
                        class="clients"
                        @click="activateListHandler('dashboard-deals-list')">
                        Clientes
                    </span>
                    <span
                        :class="{ 'reserves-active': active.name === 'dashboard-reservations-list' }"
                        class="reserves"
                        @click="activateListHandler('dashboard-reservations-list')">
                        Reservas
                    </span>
                    <span
                        :class="{ 'proposal-active': active.name === 'dashboard-proposals-list' }"
                        class="proposal"
                        @click="activateListHandler('dashboard-proposals-list')">
                        Propostas
                    </span>
                </div>

                <div class="view-all">
                    <router-link :to="active.link" class="link-all" @click="showAllHandler(active.name)">
                        Visualizar Todos
                    </router-link>
                </div>
            </div>

            <div class="actions-table">
                <div v-if="load" class="loader">
                    <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="50" :stroke="8" />
                </div>

                <div v-else class="table">
                    <ui-data-table
                        v-for="(list, index) in listsComputed"
                        v-show="list.name === active.name"
                        :key="index"
                        :name="list.name"
                        :per-page="10"
                        :filters="list.filters"
                        :columns="list.columns"
                        :sort-by="{ value: 'updated_at', dir: 'desc' }"
                        :control-fixed="true"
                        :is-fixed-list="true"
                        :borders="true"
                        :zebra="true"
                        :pagination="false"
                        :service="list.service"
                        :search-event="list.search_event"
                        :tr-component="list.tr_component"
                        :not-found-icon="list.not_found_icon"
                        :not-found-text="list.not_found_text"
                        :overlay="false"
                    />
                </div>
            </div>

            <!-- Modais para ações da lista de negócios/clientes -->
            <ui-broker-modal name="sales-deals-select-broker" />
            <ui-deal-stage-status-modal name="sales-deals-select-stage-status" success-event="modal-result-list-move-to-status" />
            <ui-procedure-modal name="deal-multiple-precedure" success-event="sales-deals-search" />
            <ui-deal-create-historical-modal name="sales-deals-select-create-historical" />

            <!-- Modais para ações da lista de reservas -->
            <ui-renew-time-modal name="sales-reservations-renew-time" />
            <ui-sold-modal name="sales-reservations-sold" />
            <ui-cancel-modal name="sales-reservations-cancel" />
            <ui-queue-modal />
            <ui-modal-message
                service="reserve"
                :above-all="true"
                name="update-reserve"
                title="Deseja realmente efetuar a venda?"
                text="Cuidado, esta ação não poderá ser desfeita."
                btn-type="danger"
                btn-text="Confirmar"
            />

            <!-- Modais para ações da lista de proposta -->
            <ui-broker-modal name="sales-proposals-select-broker" />
            <ui-procedure-modal name="proposal-multiple-precedure" success-event="sales-proposals-search" />
            <ui-deal-stage-status-modal name="sales-proposals-select-stage-status" />
        </section>
    </div>
</template>

<script>
    import { uiDataTable, uiLoadIndicator } from "@/components/ui"
    import {
        uiBrokerModal,
        uiDealCreateHistoricalModal,
        uiDealStageStatusModal
    } from '@/components/ui-facilita/modals'
    import uiProcedureModal from '@/components/ui-facilita/sales/procedure-modal'
    import { uiModalMessage } from '@/components/ui/modal'
    import uiRenewTimeModal from '@/views/sales/reservations/list/components/renew-time-modal'
    import uiSoldModal from '@/views/sales/reservations/list/components/sold-modal'
    import uiCancelModal from '@/views/sales/reservations/list/components/cancel-modal'
    import uiQueueModal from '@/views/sales/reservations/list/components/queue-modal'

    import { dealColumns, proposalColumns, reserveColumns } from './data'

    import { funnel } from '@/services/axios'
    import { storage } from '@/services/storage'

    const createLists = (funnelStageId) => ([
        {
            name: 'dashboard-deals-list',
            columns: [...dealColumns],
            filters: [{
                name: 'funnel_stage_id',
                value: funnelStageId
            }],
            tr_component: 'sales/deals/table-line',
            service: 'deal',
            search_event: 'sales-deals-search',
            not_found_icon: 'fal fa-user',
            not_found_text: 'Não foi possível encontrar nenhum Cliente'
        },
        {
            name: 'dashboard-reservations-list',
            columns: [...reserveColumns],
            filters: [],
            tr_component: 'sales/reservations/table-line',
            service: 'reserve',
            search_event: '',
            not_found_icon: 'fal fa-grip-horizontal',
            not_found_text: 'Não foi possível encontrar nenhuma Reserva'
        },
        {
            name: 'dashboard-proposals-list',
            columns: [...proposalColumns],
            filters: [],
            tr_component: 'sales/proposal/table-line',
            service: 'proposal',
            search_event: 'sales-proposals-search',
            not_found_icon: 'fal fa-file',
            not_found_text: 'Não foi possível encontrar nenhuma Proposta'
        }
    ])

    export default {
        name: 'footer-dashboard',

        components: {
            uiDataTable,
            uiLoadIndicator,
            uiBrokerModal,
            uiDealCreateHistoricalModal,
            uiDealStageStatusModal,
            uiProcedureModal,
            uiRenewTimeModal,
            uiSoldModal,
            uiCancelModal,
            uiQueueModal,
            uiModalMessage
        },

        data() {
            return {
                active: {
                    name: 'dashboard-deals-list',
                    link: { name: 'sales.deals.list' }
                },
                configurations: null,
                lists: [],
                loadedLists: ['dashboard-deals-list'],
                load: false
            }
        },
        
        computed: {
            /**
             * Computed property que retorna as listas que devem ser carregadas para o usuário
             */
            listsComputed() {
                return this.lists.filter(list => this.loadedLists.includes(list.name))
            }
        },

        created() {
            const proposalSettings = storage.get('proposal_settings')
                ? JSON.parse(storage.get('proposal_settings'))
                : null
            this.load = true
            funnel.getStages()
                .then(response => {
                    this.configurations = {
                        funnel_stage_id: Object.values(response.data)
                            .find(stage => {
                                return stage.position === proposalSettings?.homeapp?.dealStagePosition
                            })?.id
                    }

                    // Cria os dados necessários para a construção das listas
                    this.lists = [...createLists(this.configurations.funnel_stage_id)]
                })
                .catch(error => {
                    if (error && error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)
                })
                .finally(() => {
                    this.load = false
                })
            
            /**
             * Move o negócio para a etapa/status selecionada no modal
             */
            this.$root.$on('modal-result-list-move-to-status', async value => {
                let body = value?.new?.funnel_stage_id
                    ? { funnel_stage_id: value.new.funnel_stage_id }
                    : null
                const id = value?.new?.id || null
                if (body && id) {
                    if (value?.new?.funnel_stage_status_id) {
                        body['funnel_stage_status_id'] = value.new.funnel_stage_status_id
                    }

                    const { data } = await funnel.updateV2('deal/', `${id}/move`, body)

                    if (data.msg && data.status !== 'success') {
                        this.$root.$emit('close-modal-animation', false, data.msg)

                    } else {
                        await this.$root.$emit("datatable-reload-dashboard-deals-list")
                        this.$root.$emit('close-modal-animation', true, 'Atualizado com successo!')
                    }
                }
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-result-list-move-to-status')
        },

        methods: {
            /**
             * Event handler que trata o evento de seleção da listagem a ser mostrada
             */
            activateListHandler(name) {
                // Verifica se a lista selecionada ainda não foi carregada
                if (!this.loadedLists.includes(name)) this.loadedLists.push(name)

                let event = {
                    event: 'fac_button_click',
                    category: 'vue-dashboard',
                    action: 'click',
                    label: '',
                }
                this.active.name = name
                switch (name) {
                    case 'dashboard-deals-list':
                        this.active.link = { name: 'sales.deals.list' }
                        event.label = 'Lista Clientes'
                        break

                    case 'dashboard-reservations-list':
                        this.active.link = { name: 'sales.reservations.list' }
                        event.label = 'Lista Reservas'
                        break

                    case 'dashboard-proposals-list':
                        this.active.link = { name: 'sales.proposal.list' }
                        event.label = 'Lista Propostas'
                        break
                }

                // Emite o evento do Google Analytics
                this.$gtm.trackEvent(event)
            },
            /**
             * Event handler que trata o evento de quando uma das listas completas foi solicitada
             */
            showAllHandler(name) {
                let event = {
                    event: 'fac_button_click',
                    category: 'vue-dashboard',
                    action: 'click',
                    label: '',
                }
                switch (name) {
                    case 'dashboard-deals-list':
                        event.label = 'Ver Todos - Clientes'
                        break
                
                    case 'dashboard-reservations-list':
                        event.label = 'Ver Todos - Reservas'
                        break
                    
                    case 'dashboard-proposals-list':
                        event.label = 'Ver Todos - Propostas'
                        break
                }

                // Emite o evento do Google Analytics
                this.$gtm.trackEvent(event)
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>